import { useEffect } from 'react';

import { useJoin } from 'agora-rtc-react';

import { AppContext, usePrepareAppState } from '@/app/AppContext';
import { APP_ID } from '@/app/config';
import { useAutoRecording } from '@/app/mutations/RecordingMutation/context';
import { useAutoTranscription } from '@/app/mutations/TranscriptionMutation/context';
import useLocationBreadcrumbs from '@/app/location/useLocationBreadcrumbs';
import { useJoinData, useUserData } from '@/app/queries/MeetingQuery/context';
import useSoundEffects from '@/app/hooks/useSoundEffects';
import MeetingView from './MeetingView';
import { Permissions } from '../../types';


interface IMeetingPageProps {
  onEndCall(): void;
  permissions: Permissions
}

export default function MeetingPage({ onEndCall, permissions }: IMeetingPageProps) {
  const userData = useUserData();
  const appState = usePrepareAppState(permissions, userData.isHost);
  const { playJoinSound } = useSoundEffects();

  const joinData = useJoinData(APP_ID);

  useJoin(joinData, true);

  useAutoRecording(
    { joined: true }, userData.isHost && import.meta.env.VITE_ENABLE_RECORDING
  );
  useAutoTranscription(
    { joined: true }, userData.isHost && import.meta.env.VITE_ENABLE_RECORDING
  );
  useLocationBreadcrumbs(userData.isClient);

  useEffect(() => {
    playJoinSound();
  }, [playJoinSound]);

  return (
    <AppContext.Provider value={appState}>
      <MeetingView onEndCall={onEndCall} />
    </AppContext.Provider>
  );
}
